import { OrderHeader } from 'my-purchases/components/OrderHeader/OrderHeader'
import { OrderIdentifier } from 'my-purchases/components/OrderIdentifier/OrderIdentifier'
import { OrderStatusReturnInfo } from 'my-purchases/components/OrderStatusReturnInfo/OrderStatusReturnInfo'
import { PurchaseDate } from 'my-purchases/components/PurchaseDate/PurchaseDate'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import type { OrderStatusDetail } from 'my-purchases/types/purchaseStatus'
import { returnableStatuses } from 'my-purchases/utils/isOrderReturnable'
import { useMemo } from 'react'

import styles from './OrderStatusInfoContainer.module.scss'

interface OrderStatusInfoContainerProps {
	readonly order: OrderStatusDetail
	readonly orderIndex: number
	readonly isMulti: boolean
	readonly statusOnHeader: boolean
	readonly type: ORDER_TYPES
}
export function OrderStatusInfoContainer({
	order,
	orderIndex,
	isMulti,
	statusOnHeader,
	type,
}: OrderStatusInfoContainerProps) {
	const { id, creationDateTime, active, status } = order

	const isReturnable = useMemo(
		() =>
			active &&
			type === ORDER_TYPES.ONLINE &&
			returnableStatuses.includes(status),
		[status]
	)

	return (
		<>
			{!statusOnHeader && (
				<OrderHeader
					order={order}
					orderIndex={orderIndex}
					showMultiTitle={isMulti}
					className={styles.infoContent}
				/>
			)}
			<OrderIdentifier
				orderId={id}
				className={styles.infoContent}
				type={type}
			/>
			<PurchaseDate date={creationDateTime} className={styles.infoContent} />
			{isReturnable && <OrderStatusReturnInfo className={styles.infoContent} />}
		</>
	)
}
